<template>
  <div class="col-xs-6 col-sm-6 text-right hidden-xs">
    <div class="txt-color-white inline-block">
      <!-- <i class="txt-color-blueLight hidden-mobile">Última atividade da conta
        <i class="fa fa-clock-o"></i> <strong>52 minutos atrás &nbsp;</strong>
      </i> -->
    </div>
  </div>
</template>

<script>
  export default {
  }
</script>



// WEBPACK FOOTER //
// LastActivity.vue?73f49484